import {Component, Input, OnChanges, OnInit} from '@angular/core';

import {ChartDataset, ChartOptions} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {CHART_OPTION_DEFAULT_PLUGIN, CHART_OPTION_STACKED_AND_RESPONSIVE, chartColors} from '../../../core/constants';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css'],
  standalone: false,
})
export class BarChartComponent implements OnInit, OnChanges {
  @Input() public barChartOptions!: ChartOptions;
  @Input() public barChartLabels!: string[];
  @Input() public barChartData!: ChartDataset[];
  @Input() public showLegend = false;

  ChartDataLabels = ChartDataLabels;

  ngOnInit() {
    if (!this.barChartOptions || !this.barChartOptions.plugins) {
      this.barChartOptions = {
        ...CHART_OPTION_STACKED_AND_RESPONSIVE,
        ...CHART_OPTION_DEFAULT_PLUGIN
      };
    }
  }

  ngOnChanges() {
    this.barChartData.forEach((chartDatum, index) => {
      chartDatum.backgroundColor = chartColors[index % chartColors.length];
    });
  }
}

